import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { requestRetrieveAccounts } from '../../../api/admin/account/admin-account.actions';
import { requestViewAccounts } from '../../../api/admin/product/admin-product.actions';

import { setInitialFilters } from '../../../slices/admin/account-management/account-management.slice';

import AccountManagement from '../../../components/screens/admin/account-management/AccountManagement';

const AccountManagementContainer = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const { initialFilters, accounts } = useSelector(({ accountManagement }) => accountManagement);
  const dropdownAccounts = useSelector(({ party }) => party.accounts);

  const dispatch = useDispatch();

  const retrieveAccounts = useCallback(
    (filters) => {
      dispatch(
        requestRetrieveAccounts({
          filters: {
            name: filters.searchString,
            account: filters.account?.name,
            accountType: filters.type?.value,
            status: filters.status?.value,
            recordsPerPage: filters.recordsPerPage?.value,
            page: filters.page,
          },
          onSuccess: (totalAccounts) => {
            setTotalPages(Math.ceil(totalAccounts / filters.recordsPerPage.value));
            setCurrentPage(filters.page);
          },
        })
      );
      dispatch(setInitialFilters(filters));
    },
    [dispatch]
  );

  useEffect(() => {
    retrieveAccounts(initialFilters);
    dispatch(requestViewAccounts());
  }, [dispatch, retrieveAccounts, initialFilters]);

  const mappedAccounts = accounts.map((account) => ({
    externalReference: account.organisationExternalReference,
    status: account.status,
    account: account.account,
    accountType: account.accountType.join(', '),
  }));

  return (
    <AccountManagement
      accounts={mappedAccounts}
      dropdownAccounts={dropdownAccounts}
      initialFilters={initialFilters}
      currentPage={currentPage}
      totalPages={totalPages}
      retrieveAccounts={retrieveAccounts}
    />
  );
};

export default AccountManagementContainer;
